<section
    #chartElementRef
    class="agpr-top-terms-container agpr-top-terms-card agpr-contextMenu-parent"
    [id]="id"
>
    <div class="agpr-top-terms-exportMenu agpr-contextMenu top right">
        <agpr-chart-export-menu
            [id]="id + '_export'"
            iconStyleClass="fa-regular fa-arrow-right-from-bracket"
            [supportedFormats]="[ 'png', 'jpg', 'svg', 'json', 'csv', 'print' ]"
            (exportMenuClicked)="exportChart($event, chartElementRef)"
            [contextMenu]="true"
            [social]="true"
        ></agpr-chart-export-menu>
    </div>
    <h4 class="agpr-top-terms-heading">
        {{ (config?.mainTitle.mode === 'single'
            ? config.mainTitle.title
            : 'Social.intelligence.charts.topTerms.multi.heading1') | localize }}
        <agpr-dropdown
            [id]="id + '_topTermsDropdown'"
            class="agpr-top-terms-heading-metric"
            [style]="dropdownTypes.borderless"
            [agprStyle]="agprComponentStyle.social"
            [options]="options"
            ariaLabel="Social.intelligence.charts.wordCloud.dropdownLabel"
            [(ngModel)]="currentMetric"
            (ngModelChange)="onMetricChange()"
            panelStyleClass="agpr-dropdown-panelSocial"
        ></agpr-dropdown>
        <ng-container *ngIf="config?.mainTitle.mode === 'multi'">
            {{ 'Social.intelligence.charts.topTerms.multi.heading2' | localize }}
            {{ 'Social.intelligence.themeAnalytics.engagement' | localize }}
        </ng-container>
    </h4>
    <div class="agpr-top-terms-socials">
        <agpr-network-radio
            [availableNetworks]="availableNetworkTypes"
            [defaultSelection]="initialNetwork"
            (selectedNetwork)="setSocialTypes($event)"
            [showReddit]="showReddit"
            [ariaLabel]="'Social.intelligence.themeAnalytics.engagement.socialNetworksLabel'"
            [id]="id + '_networkTypes'"
        ></agpr-network-radio>
    </div>


    <div class="agpr-top-terms-charts">
        <div class="agpr-top-terms-metric-list agpr-top-terms-card">
            @if (series) {
                <agpr-top-terms-chart
                    [series]="[series]"
                    [header]="topTermsSubHeader"
                    (termSelected)="selectTerm($event)"
                    (tooltipLinkClicked)="onTooltipClicked($event)"
                    [accentColor]="accentColor"
                    [chartOptions]="chartOptions"
                    [noContentMessage]="'Common.noContentToDisplay' | localize"
                ></agpr-top-terms-chart>
            }
        </div>

        <div
            class="agpr-top-terms-card agpr-top-terms-card-related"
            role="region"
            tabindex="0"
            [attr.aria-labelledby]="id + '_topTermsChartTitle'"
        >
            <h5
                class="agpr-top-terms-chartTitle"
                [id]="id + '_topTermsChartTitle'"
            >
                <span>
                    {{ 'Social.intelligence.charts.wordCloud.relatedTo' | localize }} {{ currentTermLabel }}
                </span>
            </h5>
            <agpr-chart
                [chart]="wordCloudChart"
            ></agpr-chart>
        </div>
    </div>
</section>
